var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / CN") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-CN",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Mask",
    fill: "#F1361D",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9592954,10.1560699 L11.9708698,11.1384189 L12.5105968,11.9592954 L11.5282478,11.9708698 L10.7073712,12.5105968 L10.6957968,11.5282478 L10.1560699,10.7073712 L11.1384189,10.6957968 L11.9592954,10.1560699 Z M12.5685648,7.57446394 L13.4490988,8.01012816 L14.4255361,7.90189808 L13.9898718,8.78243212 L14.0981019,9.75886939 L13.2175679,9.32320517 L12.2411306,9.43143525 L12.6767948,8.55090121 L12.5685648,7.57446394 Z M14,4.17863279 L13.9772839,5.1607873 L14.4880339,6 L13.5058794,5.97728388 L12.6666667,6.48803387 L12.6893828,5.50587936 L12.1786328,4.66666667 L13.1607873,4.68938278 L14,4.17863279 Z M10.8992425,1.40597523 L11.6255808,2.06747064 L12.5940248,2.23257579 L11.9325294,2.9589141 L11.7674242,3.9273581 L11.0410859,3.2658627 L10.0726419,3.10075754 L10.7341373,2.37441924 L10.8992425,1.40597523 Z",
    id: "Star-2",
    fill: "#FFDC42",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-8",
    fill: "#FFDC42",
    mask: "url(#mask-2)",
    points: "6.66666667 8.22666673 4.31552566 9.90273464 5.18301844 7.1487332 2.8624406 5.43059869 5.74972164 5.40460011 6.66666667 2.66666667 7.5836117 5.40460011 10.4708927 5.43059869 8.15031489 7.1487332 9.01780768 9.90273464"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCn);
export default __webpack_public_path__ + "static/media/CN.775a72ea6adc9ec7acae1e084db88930.svg";
export { ForwardRef as ReactComponent };